import { ErrorLogComponent, type ILogger } from '@cian/error-log-component';
import * as React from 'react';

/**
 * Оборачивает каждую карточку и баннер списка в свой error boundary:
 * ошибка одного элемента убирает только его, а не весь список офферов.
 */
export const withItemErrorBoundaries = (nodes: React.ReactNode[], logger: ILogger): React.ReactNode[] =>
  nodes.map((node, index) => (
    <ErrorLogComponent key={(React.isValidElement(node) && node.key) || `item_${index}`} logger={logger}>
      {node}
    </ErrorLogComponent>
  ));
